{
  "white": "#FFFFFF",
  "black": "#000000",
  "gray": {
    "25": "#FCFCFD",
    "50": "#F9FAFB",
    "100": "#F2F4F7",
    "200": "#EAECF0",
    "300": "#D0D5DD",
    "400": "#98A2B3",
    "500": "#667085",
    "600": "#475467",
    "700": "#344054",
    "800": "#1D2939",
    "900": "#101828"
  },
  "brand": {
    "25": "#FAFBFC",
    "50": "#F5F7F9",
    "100": "#EBF0F4",
    "200": "#DFE7ED",
    "300": "#C3D3DD",
    "400": "#9CB5C7",
    "500": "#7497B1",
    "600": "#6089A5",
    "700": "#386B8F",
    "800": "#2D5672",
    "900": "#224056"
  },
  "blue": {
    "25": "#FBFCFE",
    "50": "#F5F8FC",
    "100": "#EBF2F8",
    "200": "#D6E4F1",
    "300": "#C2D7E9",
    "400": "#99BDDB",
    "500": "#70A2CD",
    "600": "#5C95C5",
    "700": "#337AB7",
    "800": "#296292",
    "900": "#1F496E"
  },
  "red": {
    "25": "#FFFBFA",
    "50": "#FEF3F2",
    "100": "#FEE4E2",
    "200": "#FECDCA",
    "300": "#FDA29B",
    "400": "#F97066",
    "500": "#F04438",
    "600": "#D92D20",
    "700": "#B42318",
    "800": "#912018",
    "900": "#7A271A"
  },
  "green": {
    "25": "#F6FEF9",
    "50": "#ECFDF3",
    "100": "#D1FADF",
    "200": "#A6F4C5",
    "300": "#6CE9A6",
    "400": "#32D583",
    "500": "#12B76A",
    "600": "#039855",
    "700": "#027A48",
    "800": "#05603A",
    "900": "#054F31"
  },
  "yellow": {
    "25": "#FFFCF5",
    "50": "#FFFAEB",
    "100": "#FEF0C7",
    "200": "#FEDF89",
    "300": "#FEC84B",
    "400": "#FDB022",
    "500": "#F79009",
    "600": "#DC6803",
    "700": "#B54708",
    "800": "#93370D",
    "900": "#7A2E0E"
  },
  "lightblue": {
    "400": "#53B1FD",
    "500": "#2E90FA"
  },
  "purple": {
    "400": "#9B8AFB",
    "500": "#7A5AF8"
  },
  "bluegray": {
    "400": "#717BBC",
    "500": "#4E5BA6"
  },
  "indigo": {
    "400": "#8098F9"
  }
}
